module.exports = "<list-view\n  title=\"Captain App Versions\"\n  transformer=\"CaptainAppVersionsTransforms\"\n  item-state=\"captainappversion\"\n  resource=\"CaptainApp\"\n  resource-params=\"{ isCityRequired: false }\"\n  paginate-event=\"$ctrl.paginateEvent\"\n  add-item-event=\"$ctrl.addItemEvent\"\n  no-items-text=\"No Captain App Versions Yet!\"\n></list-view>\n\n<main-footer></main-footer>\n<main-sidenav sections=\"$ctrl.sections\"\n  ><main-sidenav> </main-sidenav\n></main-sidenav>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/captainAppVersions/captainAppVersions.html
// module id = 2175
// module chunks = 0